import './Portfolio.css';
import { useEffect } from 'react';
import png1 from './assets/1.png';
import png2 from './assets/2.png';
import png3 from './assets/3.png';
import png4 from './assets/4.png';
import png5 from './assets/5.png';
import png6 from './assets/6.png';
import png7 from './assets/7.png';
import png8 from './assets/8.png';
import png9 from './assets/9.png';
//import png10 from './assets/10.png';

const Portfolio = ({ scrollbar }) => {
	const changeMovingCursorStyles = (type) => {
		const MovingCursor = document.querySelector('.moving-cursor');
		if (type === 'hover') {
			MovingCursor.classList.add('hovering');
		}
		if (type === 'out') {
			MovingCursor.classList.remove('hovering');
		}
	};

	const scrollToProject = (offset) => {
		scrollbar.scrollTo(0, offset, 1000);
	};

	const initializePortfolio = () => {
		const buttonsElement = document.querySelector('.portfolio .wrapper .buttons');
		if (scrollbar) {
			scrollbar.addListener(({ offset }) => {
				if (offset.y > 1150 && offset.y < 9800) {
					buttonsElement.style.position = 'fixed';
					buttonsElement.style.top = offset.y + 50 + 'px';
				} else {
					buttonsElement.style.position = 'unset';
				}
				if (offset.y > 9800) {
					buttonsElement.style.position = 'absolute';
					buttonsElement.style.top = 8800 + 'px';
				}
			});
		}
	};

	useEffect(() => {
		initializePortfolio();
	}, [scrollbar]);

	return (
		<div className="portfolio">
			<div className="wrapper">
				<div className="buttons">
					<h1>Portfolio</h1>
					<button onClick={() => scrollToProject(1150)}>
						<span>Logofolio</span>
						<span>Branding</span>
					</button>
					<button onClick={() => scrollToProject(2100)}>
						<span>Swave</span>
						<span>Branding</span>
					</button>
					<button onClick={() => scrollToProject(3050)}>
						<span>50 Makrs</span>
						<span>Branding</span>
					</button>
					<button onClick={() => scrollToProject(4000)}>
						<span>Cont</span>
						<span>Branding</span>
					</button>
					<button onClick={() => scrollToProject(4900)}>
						<span>PSM Winogrady</span>
						<span>Rebranding</span>
					</button>
					<button onClick={() => scrollToProject(5850)}>
						<span>Donstree</span>
						<span>Rebranding</span>
					</button>
					<button onClick={() => scrollToProject(6800)}>
						<span>Reconstruckt</span>
						<span>Rebranding</span>
					</button>
					<button onClick={() => scrollToProject(7750)}>
						<span>Yellow pen</span>
						<span>Rebranding</span>
					</button>
					<button onClick={() => scrollToProject(8700)}>
						<span>Hosted</span>
						<span>Rebranding</span>
					</button>
				</div>
				<div className="preview-elements">
					<div
						className="preview"
						onMouseOver={() => {
							changeMovingCursorStyles('hover');
						}}
						onMouseOut={() => {
							changeMovingCursorStyles('out');
						}}
					>
						<img src={png1}></img>
					</div>
					<div
						className="preview"
						onMouseOver={() => {
							changeMovingCursorStyles('hover');
						}}
						onMouseOut={() => {
							changeMovingCursorStyles('out');
						}}
					>
						<img src={png2}></img>
					</div>
					<div
						className="preview"
						onMouseOver={() => {
							changeMovingCursorStyles('hover');
						}}
						onMouseOut={() => {
							changeMovingCursorStyles('out');
						}}
					>
						<img src={png3}></img>
					</div>
					<div
						className="preview"
						onMouseOver={() => {
							changeMovingCursorStyles('hover');
						}}
						onMouseOut={() => {
							changeMovingCursorStyles('out');
						}}
					>
						<img src={png4}></img>
					</div>
					<div
						className="preview"
						onMouseOver={() => {
							changeMovingCursorStyles('hover');
						}}
						onMouseOut={() => {
							changeMovingCursorStyles('out');
						}}
					>
						<img src={png5}></img>
					</div>
					<div
						className="preview"
						onMouseOver={() => {
							changeMovingCursorStyles('hover');
						}}
						onMouseOut={() => {
							changeMovingCursorStyles('out');
						}}
					>
						<img src={png6}></img>
					</div>
					<div
						className="preview"
						onMouseOver={() => {
							changeMovingCursorStyles('hover');
						}}
						onMouseOut={() => {
							changeMovingCursorStyles('out');
						}}
					>
						<img src={png7}></img>
					</div>
					<div
						className="preview"
						onMouseOver={() => {
							changeMovingCursorStyles('hover');
						}}
						onMouseOut={() => {
							changeMovingCursorStyles('out');
						}}
					>
						<img src={png8}></img>
					</div>
					<div
						className="preview"
						onMouseOver={() => {
							changeMovingCursorStyles('hover');
						}}
						onMouseOut={() => {
							changeMovingCursorStyles('out');
						}}
					>
						<img src={png9}></img>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Portfolio;
